import React from 'react';

import '../../assets/styles/RequestList.css';
import {
  // fetchInDataChanges,
  // checkAndTrimRequests,
  getBtnData,
} from '../../api/Api.js';
import { getFirstFourLetters } from '../../Helpers/Helpers.js';
import { requestSorter } from '../../Helpers/Helpers.js';
import Title from '../title.js';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import DefaultComumMessage from '../Messages/DefaultComumMessage.js';
// import Input from "../Input.js";

const RequestList = () => {
  const [requestsDoneList, setRequestDoneList] = React.useState([]);
  const [alreadyTrimmed, setAlreadyTrimmed] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [cancelPaymentMessage, setCancelPaymentMessage] = React.useState(false);
  const [disabledCancelButton, setDisabledCancelButton] = React.useState(false);
  const [form, setForm] = React.useState({
    category: '',
    search: '',
  });

  function generateCorrelationId() {
    return uuidv4();
  }

  React.useEffect(() => {
    fetchRequest();
  }, []);

  const fetchRequest = async () => {
    const data = await getBtnData('requests');

    const dataSorted = requestSorter(data, 'direction');
    console.log(
      'Ordenados:',
      dataSorted.map((item) => item.countRequest),
    );
    setRequestDoneList(dataSorted);
  };

  return (
    <div className="container-request-list">
      {cancelPaymentMessage && (
        <DefaultComumMessage msg="Pagamento Cancelado com sucesso" />
      )}
      <Link to="/admin/admin">
        <Title mainTitle="Lista de Pedidos" />
      </Link>
      {requestsDoneList &&
        requestsDoneList.map((item) => (
          <div key={item.id} className="request">
            <div className="customer">
              <h3>Cliente</h3>
              <p className="customer-name">
                <span>Nome</span> {item.name}
              </p>
              <p className="customer-request">
                <span>Pedido</span> {getFirstFourLetters(item.id, 5)}/
                <strong>{item.countRequest}</strong>
              </p>
              <p>
                <span>Tipo de pagamento</span> {item.paymentMethod}
              </p>
              <p>
                <span>Valor Total R$ </span> {item.finalPriceRequest},00
              </p>
              <p>
                {' '}
                <span>Data</span> {item.dateTime}
              </p>
              <p className="idUser">
                <span></span> {item.idUser}
              </p>
            </div>
            <div>
              {item.request &&
                item.request.map((dishe, index) => (
                  <div className="dishes" key={index}>
                    <div>
                      <h3>item {index + 1}</h3>
                      <p>{dishe.name}</p>
                      <p>R$ {dishe.finalPrice},00</p>
                    </div>
                    <div className="sidedishes">
                      <p>
                        <h3>Adicionais</h3>
                      </p>
                      {dishe.sideDishes &&
                        dishe.sideDishes.map((sidedishe, index) => (
                          <div>
                            <p>{sidedishe.name}</p>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        ))}
    </div>
  );
};
export default RequestList;
